import {Component} from "react";
import Navbar from "../navbar";
import React from "react";


class KayHeader extends Component {
    toogleWidth = 1310;
    isMobileLayout = false;

    constructor(props) {
        super(props);
        this.state = {searchString: ''};
        this.onSearchInputChange = this.onSearchInputChange.bind(this);
    }

    onSearchInputChange(event) {
        this.setState({searchString: event.target.value});
    }

    onSearchClick(event) {
        event.preventDefault();
        document.getElementById('searchForm').submit()
    }

    render() {
        let styleHidden = {}
        this.isMobileLayout = window.innerWidth < this.toogleWidth;
        if (this.isMobileLayout)
            styleHidden = {display: 'none'};
        return (
            <div className="kay">
                <div className="top-page-util-bar__wrapper">
                    <div className="top-page-util-bar row">
                        <div className="ui-lg-12">
                            <div className="top-page-util-bar__right" style={styleHidden}>
                                <ul>
                                <li className="util-dropdown" id="instantCreditId"><a
                                        href={window.baseSiteUrl + "/favorites"}>
                                        Favorites&nbsp;<i className="fa fa-heart" ></i>
                                    </a></li>
                                
                                    <li><a
                                        href={window.baseSiteUrl + "/store-finder"}>
                                        Find a Store&nbsp;<i className="fa fa-map-marker"></i></a>
                                    </li>
                                    <li  id="instantCreditId">
                                        <a href={window.baseSiteUrl + "/credit-landing"}>KAY Credit Card&nbsp;</a><i className="fa fa-credit-card"></i></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="site-header-wrapper">
                    <header className="site-header row">
             
                        
                        <div className="site-header__mobile-btns site-header__mobile-btns--right" style={styleHidden}>
                         <div>
                        <form id="searchForm"
                                  action={window.baseSiteUrl + "/search/" }>
                                <div id="searchBar" className="desktop-header-search" style={{display: 'block'}}>
                                    <div className="gb-kay-sayt gb-ui">
                                        
                                        
                                    </div>
                                </div>
                            </form>
                            </div>   
                           
                            <a href={window.baseSiteUrl + "/cart"}
                               className="site-header__button--bag" id="shoppingCartBar">
                               
                            </a>
                        </div>
                        <div class="header-container"> {!this.isMobileLayout && <img class='logokay' style={{height:'20px'}} href="https://www.kay.com/?icid=LOGO" src="https://static.thepersonalizedbest.com/header/KAY-Logo.png"/>}
                        <Navbar model={this.props.model} toogleWidth={this.toogleWidth}>
                            
                            
                            {this.isMobileLayout &&
                            <div style={{display: 'flex'}}>
                                <div style={{textAlign: 'center', width: '100%'}}>
                                    <a className="logo" href={window.baseSiteUrl} title="Kay Jewelers"><img class='logokay' style={{height:'20px', position:'static', marginLeft: 0, marginTop: 10}} src="https://static.thepersonalizedbest.com/header/KAY-Logo.png"/></a>
                                </div>
                                <div style={{minWidth: '50px'}}>
                                    <div className="site-header__mobile-btns site-header__mobile-btns--right" style={{marginTop:25}}>
                                       
                                        <a href={window.baseSiteUrl + "/cart"} 
                                           className="site-header__button--bag" id="shoppingCartBar">
                                        </a>
                                    </div>
                                </div>
                            </div>
                            }
                        </Navbar>
                        </div>
                        <a className="site-header__logo" href={window.baseSiteUrl} title="Kay Jewelers"
                           style={styleHidden}>&nbsp;</a>
                         
                    </header>
                </div>
            </div>
        )
    }
}

export default KayHeader;


// WEBPACK FOOTER //
// ./src/site_interfaces/headers/kay.js